import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";

// Containers
const Container = () => import('@/containers/Container')

const Dashboard = () => import('@/views/account/Dashboard')
const CreatePlan = () => import('@/views/account/CreatePlan')
const AdjustPlan = () => import('@/views/account/AdjustPlan')

// Views - MyAccount
const MyAccountView = () => import('@/views/account/MyAccountView')

const MyInfo = () => import('@/components/account/MyInfo')
const Usage = () => import('@/components/account/Usage')
const Devices = () => import('@/components/account/Devices')
const Events = () => import('@/components/account/Events')
const Notices = () => import('@/components/account/Notices')
const ApplyCode = () => import('@/components/account/ApplyCode')
const Status = () => import('@/components/account/Status')

//

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Connect = () => import('@/views/pages/Connect')
const Register = () => import('@/views/pages/Register')
const Debug = () => import('@/views/other/Debug')


Vue.use(VueRouter)

export const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: configRoutes()
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['account/isAuthenticated']

  if (isAuthenticated || to.meta.preAuth) {
    next()
  } else {
      next({
        path: '/pages/login',
        //params: { nextUrl: to.fullPath }
      })
  }

})

function goHome(){
  router.push({ name: "Home" });
}

export {  
  goHome
}

function configRoutes() {
  return [
    {
      path: '/',
      redirect: '/account/info',
      name: 'Home',
      component: Container,
      children: [
        {
          path: '/account',
          component: MyAccountView,
          children: [
            { path: 'info', 
              component: MyInfo
            },{              
              path: 'usage',
              component: Usage
            },{
              path: 'devices',
              component: Devices
            },{
              path: 'events',
              component: Events
            },{
              path: 'code',
              component: ApplyCode
            },{
              path: 'notices',
              component: Notices
            },{
              path: 'status',
              component: Status
            }
          ],
        },
        // {
        //   path: '/dashboard',
        //   component: Dashboard,
        // },
        {
          path: '/buysubscribe',
          component: CreatePlan,
        },{
          path: 'adjustplan',
          component: AdjustPlan,
        }
        // ,{
        //   path: '/confirmplan',
        //   name: 'ConfirmPlan',
        //   component: ConfirmPlan,
        //   props: (route) => ({
        //     // user: userData,
        //     ...route.params
        //   })
        // }
      ]
    }, {
      path: '/other',
      component: {
        render(c) {
          return c('router-view')
        },
        meta: {
          noFocus: true
        },  
    },
      children: [        
        ...(process.env.NODE_ENV !== 'production' ? [{ // Only add debug route if not in production
          path: 'debug', 
          name: 'Debug',
          component: Debug,
          meta: {
            preClient: true,
            title: "Staff Debug Page",
            noFocus: true
          }
        }] : [])
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404,
          meta: {
            preAuth: true
          }
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500,
          meta: {
            preAuth: true
          }
        },
        {
          path: 'login',
          name: 'Login',
          component: Login,
          meta: {
            preAuth: true
          }
        },
        {
          path: 'connect',
          name: 'Connect',
          component: Connect,
          meta: {
            preAuth: true
          }
        },
        {
          path: 'register',
          name: 'Register',
          component: Register,
          meta: {
            preAuth: true
          }
        }

      ]
    },
    { 
      path: '/:catchAll(.*)', 
      component: Page404, // NotFoundComponent,
      name: 'NotFound'
    }
  ]
}